<template>
  <div class="card-key qm-page-bg">
    <div class="hero-section">
      <div class="brand-mark">
        <div class="brand-icon">天</div>
      </div>
      <h1 class="hero-title">天好自助</h1>
      <p class="hero-subtitle">输入卡密，即刻开启点单</p>
    </div>

    <div class="card-input-container qm-glass-card">
      <div class="input-label">卡密验证</div>
      <van-cell-group :border="false">
        <van-field
          v-model="cardKey"
          placeholder="请输入您的卡密"
          :error="!!error"
          :error-message="error"
          @input="clearError"
          class="key-field"
        />
      </van-cell-group>
      <div class="tip-message">
        <van-icon name="info-o" />
        <span>链接即买即用，不支持囤货</span>
      </div>
      <div class="button-container" :class="{ 'has-order': !!lastOrder }">
        <van-button
          type="primary"
          :block="!lastOrder"
          class="qm-btn-primary submit-btn"
          @click="submitCardKey"
          :loading="loading"
        >
          立即验证
        </van-button>
        <van-button
          v-if="lastOrder"
          type="info"
          plain
          icon="orders-o"
          class="order-btn"
          @click="goLastOrder"
        >
          查订单
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import request from "@/utils/request";
import { parseTimsOriginalData } from "@/utils/tims";

export default {
  name: "CardKey",
  data() {
    return {
      cardKey: "",
      error: "",
      loading: false,
    };
  },
  computed: {
    ...mapState(["lastOrder"]),
  },
  created() {
    this.clearSession();

    let encryptedData = this.$route.query.uuid;
    if (!encryptedData) {
      const urlParams = new URLSearchParams(window.location.search);
      encryptedData = urlParams.get("uuid");
    }
    if (encryptedData) {
      this.cardKey = encryptedData;
      this.submitCardKey();
    }
  },
  methods: {
    ...mapActions([
      "setUuid",
      "setWxid",
      "setMemberCoupon",
      "setTimsAccount",
      "setAppConfig",
      "clearSession",
    ]),
    clearError() {
      this.error = "";
    },
    goLastOrder() {
      this.$router.push({ path: "/order-detail" });
    },
    async submitCardKey() {
      if (!this.cardKey.trim()) {
        this.error = "请输入卡密";
        return;
      }
      this.loading = true;
      try {
        const uuid = this.cardKey.trim();
        const response = await request.post("/tims/check-coupon", { link: uuid });

        if (!response || !response.success) {
          throw new Error((response && response.message) || "卡密验证失败");
        }

        const data = response.data || {};
        if (data.isUsed === 1) {
          if (data.orderId || this.lastOrder) {
            this.$toast("该链接已使用，可查看订单");
            this.$router.push({
              path: "/order-detail",
              query: { orderNo: data.orderId || (this.lastOrder && this.lastOrder.orderId) },
            });
            return;
          }
          throw new Error("该卡密已使用，请联系客服更换");
        }

        if (!data.hasCoupon || !data.couponInfo) {
          throw new Error("该账号无对应优惠券，请联系客服");
        }

        const parsed = parseTimsOriginalData(data.originalData || "");
        if (String(parsed.teaType) !== "35" && data.teaType != 35) {
          // 仍允许，后台 type 为准
        }

        await this.setUuid(data.uuid || uuid);
        await this.setWxid(parsed.wxid);
        await this.setMemberCoupon(data.couponInfo);
        await this.setTimsAccount({
          ...(data.account || {}),
          phone: (data.account && data.account.phone) || parsed.phone,
          openid: (data.account && data.account.openid) || parsed.openid,
          unionid: (data.account && data.account.unionid) || parsed.unionid,
          userId: (data.account && data.account.userId) || parsed.userId,
          cardNo: (data.couponInfo && data.couponInfo.cardNo) || (data.account && data.account.cardNo) || "",
          token: (data.account && data.account.token) || parsed.token,
        });
        await this.setAppConfig({
          storeId: "4040",
          appid: "wx061e4b9f73885f51",
          name: "天好咖啡",
          dataId: data.couponTemplateId || data.couponInfo.typeNo,
          teaType: 35,
        });

        this.$toast.success(data.couponInfo.couponName || "验证成功");
        this.$router.push("/shop-list");
      } catch (error) {
        console.error("卡密验证失败:", error);
        this.error = error.message || "卡密验证失败";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-key {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
}

.hero-section {
  text-align: center;
  margin-bottom: 40px;

  .brand-mark {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;

    .brand-icon {
      width: 64px;
      height: 64px;
      border-radius: 18px;
      background: linear-gradient(135deg, #c8102e, #8b0000);
      color: #fff;
      font-size: 28px;
      font-weight: 700;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 8px 24px rgba(200, 16, 46, 0.28);
    }
  }

  .hero-title {
    font-size: 28px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 8px;
  }

  .hero-subtitle {
    font-size: 14px;
    color: #888;
  }
}

.card-input-container {
  width: 100%;
  max-width: 400px;
  padding: 24px 20px;

  .input-label {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #333;
  }

  .tip-message {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 12px 0 20px;
    font-size: 12px;
    color: #999;
  }

  .button-container {
    display: flex;
    gap: 10px;

    &.has-order .submit-btn {
      flex: 1;
    }

    .order-btn {
      flex-shrink: 0;
    }
  }
}

.key-field {
  background: #f7f8fa;
  border-radius: 10px;
  overflow: hidden;
}
</style>
